import { Bar } from "react-chartjs-2";
import Api from "utils/api";

const ServersCountChart = ({ data }) => {


    const servers = [...new Set(data.map((item) => item.server))];


    /*
    const countByServer = servers.map((server) =>
        data.filter((item) => item.server === server).length
    );

    const serversName = servers.map((server) => {
        const servidorEncontrado = Api.servers.find((s) => s.id === server);
        return servidorEncontrado ? servidorEncontrado.name : '';
    });
    */

    // Obtener datos para cada servidor
    const datosPorServidor = servers.map((server) => {
        const data2 = data.filter((item) => item.server === server);
        const conteoStateAll = data2.length;
        const conteoState1 = data2.filter((item) => item.state === 1).length;
        const conteoState2 = data2.filter((item) => item.state === 2).length;
        const conteoState4 = data2.filter((item) => item.state === 4).length;

        const servidorEncontrado = Api.servers.find((s) => s.id === server);
        const name = servidorEncontrado ? servidorEncontrado.name : '';
        const ip = servidorEncontrado ? servidorEncontrado.url.split(':')[0] : 'sin ip';

        return {
            server,
            name,
            ip,
            conteoStateAll,
            conteoState1,
            conteoState2,
            conteoState4,
        };
    });

    const chartData = {
        //labels: serversName,
        labels: datosPorServidor.map((item) => item.name + ' (' + item.ip + ')'),
        datasets: [
            {
                label: 'Todo',
                data: datosPorServidor.map((item) => item.conteoStateAll),
                backgroundColor: '#50C499',
                borderColor: '#50C499',
                borderWidth: 1,
            },
            {
                label: 'Online',
                data: datosPorServidor.map((item) => item.conteoState1),
                backgroundColor: '#8DC453',
                borderColor: '#8DC453',
                borderWidth: 1,
            },
            {
                label: 'Fallidos',
                data: datosPorServidor.map((item) => item.conteoState4),
                backgroundColor: '#c45d53',
                borderColor: '#c45d53',
                borderWidth: 1,
            },
            {
                label: 'Backup',
                data: datosPorServidor.map((item) => item.conteoState2),
                backgroundColor: '#c4ac53',
                borderColor: '#FFB705',
                borderWidth: 1,
            },
        ]
    };

    // Configuración de la gráfica
    // Configuración de la gráfica
    const chartOptions = {
        type: 'line',
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.5,
        indexAxis: 'x',
        scales: {
            x: {
                title: {
                    type: 'time',
                    display: true,
                    text: 'Servidor',
                    font: {
                        size: 16
                    }
                },
                ticks: {
                    font: {
                        size: 12
                    },
                    /*
                    // Include a dollar sign in the ticks
                    callback: function (value, index, ticks) {
                        //return formatTime(value);
                        return value;
                    }
                    */
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Numero de Fuentes',
                    font: {
                        size: 16
                    }
                },
                ticks: {
                    stepSize: 1,
                    font: {
                        size: 12
                    },
                }
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    //label: (tooltipItem) => formatTime(tooltipItem.raw),
                    //label: (tooltipItem) => tooltipItem.raw,
                },
            },
            title: {
                display: true,
                text: 'Estado por servidor',
                font: {
                    size: 18
                }
            }
        }
    };

    return (
        <Bar data={chartData} options={chartOptions} className="mt-5" />
    );
};

export default ServersCountChart